<script>
export default {
  name: "DidoApidocUsageAuthentication",
};
</script>

<template>
  <div class="q-mt-md line-height-15">
    Cette api est entièrement publique et permet uniquement de consulter et
    télécharger des données.
    <br />
    Il n'y a donc aucune authentification ou autorisation à obtenir pour pouvoir
    l'utiliser.
  </div>
</template>
